import { render } from "./Galeria.vue?vue&type=template&id=1b6f1d0a"
import script from "./Galeria.vue?vue&type=script&lang=js"
export * from "./Galeria.vue?vue&type=script&lang=js"

import exportComponent from "C:\\www\\m2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__